import React from 'react'
import styles from './home.module.css'
import Section from "../../Components/Section/Section";
import image1 from '../../assets/portfolioImage1.png'
import image2 from '../../assets/portfolioImage2.png'
import image3 from '../../assets/portfolioImage3.png'
import image4 from '../../assets/portfolioImage4.png'
import PortfolioGallery from "../../Components/PortoflioGallery/PortfolioGallery";
import { useIsSmallScreen } from '../../hooks/useIsSmallScreen';
function Portfolio() {
    const isSmallScreen = useIsSmallScreen();
    const portfolioImages = [image1, image2, image3, image4];

    return (
        <Section id="portfolio" shrink>
            <div className={styles.portfolioContainer}>
                <div data-reveal className={styles.homeHeaderContainer}>
                    <h2 className={styles.smallHeader}>Portfolio</h2>
                    <h1 className={styles.largeHeader}>My work at a glance</h1>
                </div>
                {isSmallScreen ? (
                    <div data-reveal className={styles.revealItem}>
                        <PortfolioGallery photos={portfolioImages} />
                    </div>
                ) : (
                    <div className={styles.portfolioGrid}>
                        {portfolioImages.map((image, index) => (
                            <div data-reveal key={index} className={styles.portfolioImageWrapper}>
                                <img src={image} alt={`Portfolio ${index + 1}`} className={styles.portfolioImage}/>
                            </div>
                        ))}
                    </div>
                )}
            </div>
        </Section>
    )
}

export default Portfolio
